// Keybar telemetry readout: a live one-liner proving the speed story
// (call count, median latency, JSON-repair rate). Updates as calls land.

import { onTrace, traceStats } from "../core/telemetry";

let sessionStart = Date.now();

export function resetTelemetryStat(): void { sessionStart = Date.now(); render(); }

function render(): void {
  const el = document.getElementById("telemetryStat");
  if (!el) return;
  const s = traceStats(sessionStart);
  if (!s.calls) { el.textContent = ""; return; }
  const repaired = Object.values(s.byKind).reduce((a, k) => a + k.repaired, 0);
  const pct = Math.round((repaired / s.calls) * 100);
  el.textContent = `model: ${s.calls} calls · p50 ${s.p50 ?? "—"} ms${pct ? ` · ${pct}% repaired` : ""}${s.errors ? ` · ${s.errors} err` : ""}`;
}

export function initTelemetryStat(): void {
  onTrace(() => {
    // cheap coalesce: at most one paint per animation frame
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; render(); });
  });
  render();
}
let pending = false;
